import Button from 'Components/Base/Button'
import React, { useState } from 'react'
import Modal from 'react-modal'
import styled, { useTheme } from 'styled-components'
import Column from '../../../../../Components/Base/Column'
import Row from '../../../../../Components/Base/Row'
import Typography from '../../../../../Components/Base/Typography'
import { Form, Col, InputGroup } from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker';
import { StyledButtonRow } from 'Pages/AppointmentPage'
import Icon from 'Components/Base/Icon'


interface Props {
  modalOpen: boolean
  toggleModal: (isOpen: boolean) => void
  onSubmit: (weightDetail: any) => void
}
export default function AddWeightModal({ modalOpen, toggleModal, onSubmit }: Props) {
  const [weightDetail, setWeightDetail] = useState<{ wDate: Date | undefined; wTime: Date | undefined; wWeight: number | undefined }>({
    wDate: undefined,
    wTime: undefined,
    wWeight: undefined,
  })
  const [isSubmitted, setIsSubmitted] = useState(false);

  const customStyles = {
    content: {
      width: 'fit-content',
      height: 'fit-content',
      overflow: 'none',
      top: '50%',
      left: '50%',
      right: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      paddingRight: '0',
    },
    input: {
      border: 'none',
      fontSize: '16px',
      padding: '5px',
    },
    calendar: {
      backgroundColor: '#f0f0f0',
      border: '1px solid red',
    }
  }
  const theme = useTheme()

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    onSubmit(weightDetail);
    weightDetail.wDate = undefined
    weightDetail.wTime = undefined
    weightDetail.wWeight = undefined
    toggleModal(false);
  };


  return (

    <StyledModalContainer style={{ display: modalOpen ? 'block' : 'none' }} >
      <Modal isOpen={modalOpen} onRequestClose={() => toggleModal(false)} style={customStyles} ariaHideApp={false} >
        <StyledModalHeader styles={{ backgroundColor: theme.colors.darkGray, fontFamily: 'inherit' }} >
          <Typography color="white" size={18} styles={{ margin: 'auto' }} >
            Update My Weight
          </Typography>
          <div onClick={() => toggleModal(false)} style={{ cursor: 'pointer' }} >
            <Icon name="circleX" color="white" styles={{ height: '25px', width: '25px' }} />
          </div>
        </StyledModalHeader>
        <Column styles={{ marginTop: '6vh' }}>
          <Form onSubmit={handleSubmit}>
            <StyledInputGroup as={Row} className="mb-3">
              <StyledInputLabel column sm="2"  >Date: </StyledInputLabel>
              <Col sm="8">
                <StyledReactDatePicker
                  selected={weightDetail.wDate}
                  className={"start-date-picker"}
                  onChange={(date: Date) => {
                    setWeightDetail((prevState) => ({
                      ...prevState,
                      wDate: date,
                    }))
                  }}
                  aria-describedby="basic-addon0"
                  showYearDropdown
                  scrollableYearDropdown
                  maxDate={new Date()}
                  required={true}


                /></Col>
              <StyledInputLabel column sm="2" ></StyledInputLabel>
            </StyledInputGroup>

            <StyledInputGroup as={Row} className="mb-3" >
              <StyledInputLabel column sm="2">Time: </StyledInputLabel>
              <Col sm="8">
                <StyledReactDatePicker
                  selected={weightDetail.wTime}
                  className="start-date-picker"
                  onChange={(date: Date) => {
                    setWeightDetail((prevState) => ({
                      ...prevState,
                      wTime: date,
                    }))
                  }}
                  aria-describedby="basic-addon1"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  required={true}
                /></Col>
              <StyledInputLabel column sm="2" ></StyledInputLabel>
            </StyledInputGroup>


            <StyledInputGroup as={Row} className="mb-3">
              <Col sm="2"> </Col>
              <Col sm="8">
                <StyledFormInput
                  required
                  type="number"
                  placeholder=""
                  value={weightDetail.wWeight}
                  aria-describedby="basic-addon2"
                  onChange={(e) => {
                    setWeightDetail((prevState) => ({
                      ...prevState,
                      wWeight: +e.target.value,
                    }))

                  }}

                />
              </Col>
              <StyledInputLabel column sm="2" style={{ fontWeight: 'normal' }} >lbs</StyledInputLabel>
            </StyledInputGroup >

            <StyledButtonRow>
              <StyledSubmitButton
                text="Submit"
                type='submit'
              />
            </StyledButtonRow>


          </Form>


        </Column>



      </Modal>
    </StyledModalContainer>
  )
}

const StyledModalContainer = styled.div`
  height: 60px;
  width: 15%;
  position: fixed;
  inset: 37% auto 40px 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`

const StyledModalHeader = styled(Row)`
  background-color: ${({ theme }) => theme.colors.primary1};
  text-align:center;
  position: absolute;
  margin-bottom: 80px;
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 10px 20px;
  top: 0;
  left: 0;
  justify-content: space-between;
  font-weight:700;
`
const StyledReactDatePicker = styled(ReactDatePicker)`
  background-color: #b8dde1;
  width:100%;
  font-family:Raleway;
  font-size:22px;
  font-weight:400;
  color:black;
  border: 1px solid black;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
`
const StyledFormInput = styled(Form.Control)`
  background-color: #b8dde1!important;
  width:100%;
  font-family:Raleway;
  font-size:22px;
  font-weight:400;
  height:40px;
  color:black;
  border: 1px solid black!important;
  
`

const StyledInputLabel = styled(Form.Label)`
font-family:Raleway;
font-size:22px;
font-weight:700;
padding:0;
`

const StyledInputGroup = styled(InputGroup)`
margin-bottom: .5rem!important;
`
const StyledSubmitButton = styled(Button)`
background-color: ${({ theme }) => theme.colors.charts.inRange};
font-family:Raleway;
font-size:18px;
font-weight:700;
padding-left:10%;
padding-right:10%;
`
